import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Drawer,
  IconButton,
  // Icon,
  Typography,
  Icon,
  Breadcrumbs,
  Link,
  useTheme,
  Box,
  // Divider,
} from '@mui/material';
import { DrawerProps } from '@mui/material/Drawer';
import useMenus, { MenuProps } from './use-menus';
import { ChevronRight, ChevronLeft } from '@mui/icons-material';
import { Placeholder } from '@/components/base/placeholder';

interface SidebarProps extends Omit<DrawerProps, 'open' | 'onClose'> {
  hasExpand: boolean;
  setHasExpand: Function;
}

export const Sidebar = (props: SidebarProps) => {
  const { hasExpand, setHasExpand, ...rest } = props;
  const navigate = useNavigate();
  const { menus, pid, cid, parent: parentMenu, child: childMenu } = useMenus();
  const theme = useTheme();
  const [vid, setVid] = React.useState<number | undefined>(pid);
  React.useEffect(() => {
    setVid(pid);
  }, [pid]);

  const handleParentClick = (parent: MenuProps) => {
    setVid(parent.id);
    if (parent.path && !parent.disabled && parent.id !== pid) {
      navigate(parent.path);
    }
  };

  const handleChildClick = (child: MenuProps) => {
    if (child.path && !child.disabled && child.id !== cid) {
      navigate(child.path);
    }
  };

  const handleCloseDrawer = () => {
    setHasExpand(false);
  };

  const handleOpenDrawer = () => {
    setHasExpand(true);
  };

  return (
    <>
      <Drawer {...rest} open={hasExpand} onClose={handleCloseDrawer}>
        <Box
          sx={{
            padding: theme.spacing(0, 2),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            ...theme.mixins.toolbar,
          }}
        >
          <IconButton onClick={handleCloseDrawer}>
            <ChevronLeft />
          </IconButton>
        </Box>
        <Box
          sx={{
            display: 'flex',
          }}
        >
          <Box
            sx={{
              flexShrink: 0,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {menus.map((parent, idx) => (
              <Box
                key={idx}
                sx={{
                  padding: theme.spacing(1),
                }}
              >
                <IconButton
                  size="medium"
                  color={
                    pid === parent.id
                      ? 'primary'
                      : vid === parent.id
                      ? 'secondary'
                      : 'default'
                  }
                  onClick={() => handleParentClick(parent)}
                >
                  <Icon>{parent.icon}</Icon>
                </IconButton>
              </Box>
            ))}
          </Box>
          {menus.map((parent, idx) => {
            return (
              <Box
                key={idx}
                sx={{
                  flex: 1,
                  overflow: 'hidden',
                  padding: theme.spacing(1, 2),
                }}
                hidden={parent.id !== vid}
              >
                {parent.children ? (
                  <div>
                    <Breadcrumbs aria-label="breadcrumb">
                      <Link color="inherit">{parentMenu?.label || '--'}</Link>
                      <Link color="inherit">{childMenu?.label || '--'}</Link>
                      {/* <Typography color="textPrimary">Breadcrumb</Typography> */}
                    </Breadcrumbs>
                    <Box
                      sx={{
                        padding: theme.spacing(1, 0),
                      }}
                    >
                      {parent?.children.map((child, index) => {
                        return (
                          <Box
                            key={index}
                            onClick={() => handleChildClick(child)}
                            sx={{
                              padding: theme.spacing(1, 0),
                              color:
                                child.id === cid
                                  ? theme.palette.primary.main
                                  : theme.palette.text.disabled,
                            }}
                          >
                            <Typography variant="subtitle2">
                              {child.label}
                            </Typography>
                          </Box>
                        );
                      })}
                    </Box>
                  </div>
                ) : (
                  <Placeholder size={80} title="no children router" />
                )}
              </Box>
            );
          })}
        </Box>
      </Drawer>
      <Box
        sx={{
          position: 'fixed',
          left: '0',
          top: '50%',
          transform: 'translateY(-50%)',
        }}
        hidden={hasExpand}
      >
        <IconButton onClick={handleOpenDrawer}>
          <ChevronRight />
        </IconButton>
        {/* open menu */}
      </Box>
    </>
  );
};

export default Sidebar;
